import React, { useState } from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import AppDatePicker from "../../common/app-date-picker";

import JobsTable from "./JobsTable";
import JobsLogTable from "./JobsLogTable";
import CronSearchInput from "../CronSearchInput";

function UsersTab(props) {
  const [searchValue, setSearchValue] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [executedBy, setExecutedBy] = useState("");
  const [notificationCount, setNotificationCount] = useState("");
  const [refreshKey, setRefreshKey] = useState(0);

  const updateSearchValue = (value) => {
    setSearchValue(value);
  };

  return (
    <div>
      <Container maxWidth={false}>
        {/* <JobsTable refreshKey={refreshKey} setRefreshKey={setRefreshKey} /> */}

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            mt: 3,
            ml: 3,
            mb: 2,
            flexWrap: "wrap",
          }}
        >
          <CronSearchInput updateSearchValue={updateSearchValue} />

          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
            <Box sx={{ width: 200 }}>
              <AppDatePicker
                label="From Date"
                value={fromDate}
                onChange={(newValue) => setFromDate(newValue)}
                disableFuture
                slotProps={{
                  field: { clearable: true },
                  textField: { size: "small" },
                }}
                sx={{ width: "100%" }}
              />
            </Box>

            <Box sx={{ width: 200 }}>
              <AppDatePicker
                label="To Date"
                value={toDate}
                onChange={(newValue) => setToDate(newValue)}
                disableFuture
                slotProps={{
                  field: { clearable: true },
                  textField: { size: "small" },
                }}
                sx={{ width: "100%" }}
              />
            </Box>
          </LocalizationProvider>

          <TextField
            label="Executed By"
            size="small"
            value={executedBy}
            onChange={(e) => setExecutedBy(e.target.value)}
          />

          <TextField
            label="Notification Count"
            type="number"
            size="small"
            value={notificationCount}
            onChange={(e) => setNotificationCount(e.target.value)}
          />
        </Box>

        <JobsLogTable
          searchInput={searchValue}
          fromDate={fromDate}
          toDate={toDate}
          executedBy={executedBy}
          notificationCount={notificationCount}
          refreshKey={refreshKey}
        />
      </Container>
    </div>
  );
}

export default UsersTab;